import { Component } from '@angular/core';

@Component({
  selector: 'app-unit-title',
  standalone: true,
  imports: [],
  templateUrl: './unit-title.component.html',
  styleUrl: './unit-title.component.scss'
})
export class UnitTitleComponent {

}
